// F9.2-X · Frente 1 — Lock de fonte de KPIs.
// Constante única importada por componentes que exibem badge "Origem dos indicadores".
// Não alterar sem PR de rollback explícito (ver docs/architecture/ubs_eap_invariants.md R5).

export const EVM_KPI_SOURCE = {
  view: 'emp_vw_indicadores_blindados',
  locked: true,
  decision: 'F9.2-X · Frente 1',
} as const;

export type EvmKpiSource = typeof EVM_KPI_SOURCE;
